import { render, staticRenderFns } from "./NavHeaderItem.vue?vue&type=template&id=47903cde"
import script from "./NavHeaderItem.vue?vue&type=script&lang=js"
export * from "./NavHeaderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports